import {DrawerProps} from '@mantine/core';
import {I18n} from '@aws-amplify/core';
import {RecordForm} from "../forms/RecordForm.tsx";
import {MeterAssignment} from "../types.ts";
import {PlatformDrawer} from '@flexinet/ui-components';

export const FormDrawer = (
    {
        record,
        handleSubmit,
        opened,
        onClose,
        ...rest
    }: DrawerProps & {
        record: MeterAssignment,
        // Resolves true when the record was saved. The drawer closes ONLY then: a server
        // error leaves it open with the operator's values.
        handleSubmit: (values: MeterAssignment) => Promise<boolean>
    }) => {

    const title = record?.id ? I18n.get('Edit Meter Assignment') : I18n.get('Add Meter Assignment');

    const handleFormSubmit = async (values: MeterAssignment) => {
        const saved = await handleSubmit(values);
        if (saved) {
            onClose();
        }
    };

    return (
        <PlatformDrawer
            opened={opened}
            onClose={onClose}
            title={title}
            {...rest}
        >
            <RecordForm
                record={record}
                handleSubmit={handleFormSubmit}
                handleCancel={onClose}
            />
        </PlatformDrawer>
    )
};
